import { styled, TableCell } from '@mui/material';

const RowTableCell = styled(TableCell)`
  font-size: 1.6rem;
  font-family: var(--enFont);
  color: black;
`;

export default RowTableCell;
